import { call, put, takeEvery } from "redux-saga/effects"

import {

  GET_TEST_DEFINITIONS,
  ADD_NEW_TEST_DEFINITION,
  UPDATE_TEST_DEFINITION,
  DELETE_TEST_DEFINITION,

} from "./actionTypes"

import {

  getTestDefinitionsSuccess,
  addTestDefinitionSuccess,
  updateTestDefinitionSuccess,
  deleteTestDefinitionSuccess,
  testDefinitionsApiError

} from "./actions"

import {
  getTestDefinitions,
  addNewTestDefinition,
  updateTestDefinition,
  deleteTestDefinition,

} from "../../../helpers/backend_helper/backend_helper"


function* fetchTestDefinitions() {
  try {
    const response = yield call(getTestDefinitions)
    yield put(getTestDefinitionsSuccess(response))
  } catch (error) {
    yield put(testDefinitionsApiError(error))
  }
}

function* onAddNewTestDefinition({ payload: testDefinition }) {
  try {
    const response = yield call(addNewTestDefinition, testDefinition)
    yield put(addTestDefinitionSuccess(response))
  } catch (error) {
    yield put(testDefinitionsApiError(error))
  }
}

function* onUpdateTestDefinition({ payload: testDefinition }) {
  try {
    const response = yield call(updateTestDefinition, testDefinition)
    yield put(updateTestDefinitionSuccess(response))
  } catch (error) {
    yield put(testDefinitionsApiError(error))
  }
}

function* onDeleteTestDefinition({ payload: testDefinition }) {
  try {
    const response = yield call(deleteTestDefinition, testDefinition)
    yield put(deleteTestDefinitionSuccess(response))
  } catch (error) {
    yield put(testDefinitionsApiError(error))
  }
}

function* testManagementSaga() {
  yield takeEvery(GET_TEST_DEFINITIONS, fetchTestDefinitions)
  yield takeEvery(ADD_NEW_TEST_DEFINITION, onAddNewTestDefinition)
  yield takeEvery(UPDATE_TEST_DEFINITION, onUpdateTestDefinition)
  yield takeEvery(DELETE_TEST_DEFINITION, onDeleteTestDefinition) 
}

export default testManagementSaga